import { z } from 'zod';

/**
 * As letras das alternativas, na ordem do `choices` da questão: a posição na
 * lista é o índice 0-based que o back usa. São cinco porque a API da Aristo
 * manda até cinco — prova com quatro só não usa a última.
 */
export const ANSWER_OPTIONS = ['A', 'B', 'C', 'D', 'E'] as const;

export const AnswerOptionSchema = z.enum(ANSWER_OPTIONS);

export type AnswerOption = z.infer<typeof AnswerOptionSchema>;

/** Questão → letra marcada. Questão em branco **não tem chave**. */
export type Answers = Record<number, AnswerOption>;

/** O índice que o back recebe e devolve, a partir da letra da tela. */
export function toAnswerIndex(answer: AnswerOption): number {
  return ANSWER_OPTIONS.indexOf(answer);
}

/**
 * O caminho de volta. Índice fora da lista (negativo, ou além do `E`) devolve
 * `null`: a questão fica em branco em vez de mostrar letra errada.
 */
export function toAnswerOption(index: number): AnswerOption | null {
  return ANSWER_OPTIONS[index] ?? null;
}

/**
 * Grava a resposta confirmada da questão, ou a deixa em branco com `null`. A
 * questão em branco **sai do objeto**, e não vira `undefined`, porque é a
 * contagem de chaves que diz quantas foram respondidas.
 */
export function setAnswer(
  answers: Answers,
  question: number,
  answer: AnswerOption | null,
): Answers {
  if (answer) return { ...answers, [question]: answer };
  const rest = { ...answers };
  delete rest[question];
  return rest;
}

/** As respostas no formato do envio: número da questão em texto → índice. */
export function toAnswerIndexes(answers: Answers): Record<string, number> {
  return Object.fromEntries(
    Object.entries(answers).map(([number, letter]) => [
      number,
      toAnswerIndex(letter),
    ]),
  );
}
